import PropTypes from 'prop-types';
import React, { Component } from 'react';

import defined from '~app/core/defined';

class ImageBlob extends Component {

  state = {
    imageUrl: null,
  };

  componentWillMount() {
    this.setImageUrl(this.props.blob);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.blob !== this.props.blob) {
      this.setImageUrl(nextProps.blob);
    }
  }

  componentWillUnmount() {
    this.setImageUrl(null);
  }

  setImageUrl(imageBlob) {
    if (defined(this.state.imageUrl)) {
      URL.revokeObjectURL(this.state.imageURL);
    }

    this.setState({
      imageUrl: this.imageUrlForBlob(imageBlob),
    });
  }

  imageUrlForBlob(imageBlob) {
    return defined(imageBlob) ? URL.createObjectURL(imageBlob) : null;
  }

  render() {
    return (
      <div className="ImageBlob"
        // Merge any style passed into the ImageBlob component.
        // We may be using an object URL passed directly as a prop,
        // or we may be using a blob that we wrapped in an object URL that
        // we manage internally.
        style={{
          ...this.props.style,
          'backgroundImage': defined(this.props.imageUrl) ?
            `url(${this.props.imageUrl})` :
            `url(${this.state.imageUrl})`,
        }}
        onClick={this.props.onClick}
      >
        {this.props.children}
      </div>
    );
  }
}

ImageBlob.propTypes = {
  blob: PropTypes.object,
  imageUrl: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onClick: PropTypes.func,
};

export default ImageBlob;



// WEBPACK FOOTER //
// ./src/components/ImageBlob.js